import SFetch from '@app/utils/sfetch'

const firmId = (): string => window.Silverfin.currentFirmId

export type PinnedIdsResponse = {
  segment_ids: number[]
  partner_segment_ids: number[]
}

type PinTarget = { segmentId?: number | null; partnerSegmentId?: number | null }

type PinBody = {
  segment_id: number | null
  partner_segment_id: number | null
}

const buildPinBody = ({ segmentId, partnerSegmentId }: PinTarget): PinBody => ({
  segment_id: segmentId ?? null,
  partner_segment_id: partnerSegmentId ?? null,
})

const emptyPinnedIds: PinnedIdsResponse = {
  segment_ids: [],
  partner_segment_ids: [],
}

export const pinSegment = async (
  target: PinTarget
): Promise<PinnedIdsResponse> => {
  const response = await SFetch.json<PinnedIdsResponse>(
    window.Silverfin.Routes.insights_pinned_segments_path(firmId()),
    { method: 'POST', body: buildPinBody(target) },
    { camelizeJSON: false }
  )
  return response ?? emptyPinnedIds
}

export const unpinSegment = async (
  target: PinTarget
): Promise<PinnedIdsResponse> => {
  const response = await SFetch.json<PinnedIdsResponse>(
    window.Silverfin.Routes.insights_pinned_segments_path(firmId()),
    { method: 'DELETE', body: buildPinBody(target) },
    { camelizeJSON: false }
  )
  return response ?? emptyPinnedIds
}
